<template>
  <div>









      <CRow>
          <CCol md="12">



              <CCard class="center-div">




                  <b-row class="mt-2">


                    <b-col class="p-5">
                      <b-alert show variant="info" style="text-align: center">به نرم افزار سایان خوش آمدید</b-alert>
                    </b-col>


                  </b-row>

              </CCard>



              <div>




                  <b-row class="">




                  </b-row>


              </div>

          </CCol>





          <CCol md="3">

          </CCol>

      </CRow>










  </div>
</template>
<style src="../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import MainChartExample from './charts/MainChartExample'
import WidgetsDropdown from './widgets/WidgetsDropdown'
import WidgetsBrand from './widgets/WidgetsBrand'

import BootstrapTable from 'bootstrap-table'

import { CChartLineSimple, CChartBarSimple } from './charts/index'

import Multiselect from 'vue-multiselect'

import addIssue from './issue/add'
import issueItemShow from './issue/item'

export default {
  name: 'Dashboard',
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
      CChartLineSimple,
      CChartBarSimple,

      Multiselect,

      addIssue,
      issueItemShow,

      BootstrapTable




  },
  data () {
    return {
      selected: 'Month',





        auth: {
            headers: {
                Authorization: 'bearer ' + localStorage.getItem('token')
            }
        },

        role: localStorage.getItem('role'),
        authUser:
            {
                id:localStorage.getItem('id'),
            },



        loadMore: true,
        page: 1,
        pageSize: 10,
        voice: '',

        courseCategories:[],
        fileCategories:[],
        forumCategories:[],
        forums:[],


        issues:[],
        issueText: 0,


        rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

        showVoiceRecorder: false,
        showFileUploader: false,
        showImageUploader: false,
        showVideoUploader: false,

        src: null,
        srcPlay: null,

        issueAsCourse: false,
        issueAsForum: false,

        courseDisabled: false,
        forumDisabled: false,

        newComment:'',
        newReply:'',

        options:[],

        selectedTags: [],
        tags: [],
        isLoading: false,




        typeOptions: [
            { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
            { value: 'bug', text: 'ایراد (Bug)' },
            { value: 'task', text: 'فعالیت (Task)' },
            { value: 'story', text: 'لیست (Story)' },
            { value: 'epic', text: 'نسخه/فیچر (Epic)' },
            { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
            { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

        ],



        warningModal: false,


        search: {

                title: '',
                description: '',
                type: '',
                project_id: '',
                section_id: '',
                process_id: '',
                step_id: '',
                board_id: '',

                created_at_from: '',
                created_at_to: '',
                due_date: '',
                start_date: '',
                done_date_from: '',
                done_date_to: '',
                close_date: '',

                priority: '',
                contact_id: '',
                order_id: '',
                person_id: '',
                created_by: '',
                updated_by: '',
        },


        contact_id: '',




        addIssue: {
            parent_id: null,
            reply_id: null,
            sprint_id: null,
            board_id: null,
            process_id: null,
            section_id: null,
            step_id: null
        },

        processes: [],
        steps: [],
        orders: [],
        contacts: [],
        projects: [],











        columns: [
            {
                title: 'Item ID',
                field: 'id'
            },
            {
                field: 'name',
                title: 'Item Name'
            }, {
                field: 'price',
                title: 'Item Price'
            }
        ],
        data: [
            {
                id: 1,
                name: 'Item 1',
                price: '$1'
            }
        ],
        tableOptions: {
            search: true,
            showColumns: true
        }




    }
  },


    watch: {


        search: {
            deep: true,
            handler() {

                // this.getSteps(this.search.process_id)

            }
        }



        },



    beforeRouteUpdate(to, from, next) {
        // this.getProcesses()
        // this.getSteps()
        // this.getProjects()
        // this.getOrders()
        // this.getContacts()
        // this.getUsers()
    },


    mounted() {



        //
        // this.getCourseCategories()
        // this.getFileCategories()
        // this.getForumCategories()
        // this.getForums()
        //


        // this.getProcesses()
        // this.getSteps()
        // this.getProjects()
        // this.getOrders()
        // this.getContacts()
        // this.getUsers()




    },



    methods: {
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },







        getMoreIssues(){
            var app = this;



            if(app.loadMore == true){

                axios.get('/api/intro/index' +
                    '?title='+app.search.title+
                    '&description='+app.search.description+
                    '&type='+app.search.type+
                    '&project_id='+app.search.project_id+
                    '&section_id='+app.search.section_id+

                    '&process_id='+app.search.process_id+
                    '&step_id='+app.search.step_id+
                    '&board_id='+app.search.board_id+

                    '&created_at_from='+app.search.created_at_from+
                    '&created_at='+app.search.created_at_to+
                    '&created_at_to='+app.search.due_date+
                    '&start_date='+app.search.start_date+
                    '&done_date_from='+app.search.done_date_from+
                    '&done_date_to='+app.search.done_date_to+
                    '&close_date='+app.search.close_date+

                    '&priority='+app.search.priority+
                    '&contact_id='+app.search.contact_id+
                    '&order_id='+app.search.order_id+
                    '&person_id='+app.search.person_id+
                    '&created_by='+app.search.created_by+
                    '&updated_by='+app.search.updated_by+
                '&page='+app.page , app.auth)
                    .then(res => {
                        // app.issues.concat(res.data.data)
                        res.data.data.forEach(
                            (val)=>{ app.issues.push(val)});

                        app.page++

//                        if(res.data.data.lenght == null)
//                            app.endMore = true

                        // Stop scroll-loader
                        res.data.data.length < app.pageSize && (app.loadMore = false)
                    })
                    .catch(error => {
                        console.log(error);
                    })

            }


        },


        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight
            const bottomOfPage = visible + scrollY >= pageHeight
            return bottomOfPage || pageHeight < visible
        },

        pluck(array, key) {
            return array.map(function (obj) {
                return obj[key];
            });
        },



        onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.srcPlay =  window.URL.createObjectURL(data)
            this.src =  data

        },

        headerStyles(issue){
            if (issue.type == 1)
                return '2px solid #a01c7d'
            else if (issue.type == 'ticket')
                return '2px solid #263238'
            else if (issue.type == 'bug')
                return '2px solid #ff2c00'
            else if (issue.type == 'task')
                return '2px solid #00e853'
            else if (issue.type == 'story')
                return '2px solid #0097a7'
            else if (issue.type == 'epic')
                return '2px solid #0288ff'
            else if (issue.type == 'lead')
                return '2px solid #950057'
            else if (issue.type == 'meeting')
                return '2px solid #8e24aa'
            else if (issue.type == 'event')
                return '2px solid #eeb600'
            else if (issue.type == 'message')
                return '2px solid #0208ff'
            else if (issue.type == 'report')
                return '2px solid #888'
            else
                return '2px solid #999999'
        },


        boardColor(boardID){
            if (boardID == 1)
                return '#ee6600'
            else if (boardID == 2)
                return '#ffd600'
            else if (boardID == 3)
                return '#aeb130'
            else if (boardID == 4)
                return '#64dd17'
            else if (boardID == 5)
                return '#0097a7'
            else if (boardID == 6)
                return '#00bfa5'
            else
                return ''
        },

        typeBadgeStyles(issue){
            if (issue.type == 1)
                return '#a01c7d'
            else if (issue.type == 'ticket')
                return '#263238'
            else if (issue.type == 'bug')
                return '#ff2c00'
            else if (issue.type == 'task')
                return '#00e853'
            else if (issue.type == 'story')
                return '#0097a7'
            else if (issue.type == 'epic')
                return '#0288ff'
            else if (issue.type == 'lead')
                return '#950057'
            else if (issue.type == 'meeting')
                return '#8e24aa'
            else if (issue.type == 'event')
                return '#eeb600'
            else
                return '#999999'
        },


        customLabel(option) {
            //   console.log(option.title)

            //   this.item.tags.push(option)
            return `${option.title}`

        },


        ajaxFindTag(query){

        },


        limitText (count) {
            return `and ${count} other tags`
        },
        asyncFind (query) {
            this.isLoading = true
            this.ajaxFindTag(query).then(response => {
                this.tags = response
                this.isLoading = false
            })
        },
        clearAll () {
            this.selectedTags = []
        },









    }
}
</script>











<style scoped>


    tr{
        box-shadow: 0px 4px 4px rgba(0,0,0,.15);

    }






    .tree ul {
        margin: 0 0 0 15em;
        padding: 0;
        list-style: none;
        /*color: #369;*/
        position: relative;
    }
    .tree:before, .tree ul:before {
        content: "";
        display: block;
        width: 0px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 202px;
        border-left: 1px solid;
        /*background: white;*/
        /*z-index: -1;*/
    }
    .tree li {
        font-weight: bold;
        line-height: 3em;
        margin: 0;
        padding: 1.5em 0 0 2em;
        position: relative;
    }
    .tree li:before {
        border-top: 1px solid;
        content: "";
        display: block;
        height: 100%;
        left: 400px;
        margin-top: 1em;
        position: absolute;
        top: 1.5em;
        width: 20em;


    }
    .tree li:last-child:before {
        /*background: white;*/
        bottom: 0;
        height: auto;
        top: 1.5em;
    }
    .tree > li:before {
        border-top: none !important;
    }
    .tree li div {
        border-radius: 5px;
        /*border: 1px solid #afafaf;*/
        margin: 0;
        max-width: 20em;
        min-width: 15em;
        /*padding: 0.25em 0.5em;*/
        /*background: white;*/
        /*box-shadow: 1px 1px 4px #8F949A;*/
        /*color: #369;*/
        /*font-weight: bold;*/
        overflow: hidden;
    }

    ul.tree {
        margin-right: 0px;
    }
    ul.tree:before {
        border-right: none;
    }

    .sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        width: 100%;
    }

</style>
